export default "__VITE_ASSET__BNcXSjCu__"